import React from 'react';

import './UnreadNotificationsBubble.scss';

type Props = {
  classNames: string;
  count: number;
};

function UnreadNotificationsBubble({ classNames = '', count = 0 }: Props) {
  return (
    <div className={`unread-notifications-bubble d-flex justify-content-center align-items-center ${classNames}`}>
      {count}
    </div>
  );
}

export default UnreadNotificationsBubble;
